import { IAssociatedToken } from 'types/associatedTokens';
import { create } from 'zustand';

interface AssociatedTokensStore {
  tokens: IAssociatedToken[];
  total: number;
  page: number;
  pageSize: number;
  searchQuery: string;
  isHidden: boolean;
  isLoading: boolean;

  setTokens: (tokens: IAssociatedToken[]) => void;
  setTotal: (total: number) => void;
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
  setSearchQuery: (searchQuery: string) => void;
  setIsHidden: (isHidden: boolean) => void;
  setIsLoading: (isLoading: boolean) => void;
}

export const useAssociatedTokensStore = create<AssociatedTokensStore>((set) => ({
  tokens: [],
  total: 0,
  page: 1,
  pageSize: 10,
  searchQuery: '',
  isHidden: false,
  isLoading: false,

  setTokens: (tokens) => set({ tokens }),
  setTotal: (total) => set({ total }),
  setPage: (page) => set({ page }),
  setPageSize: (pageSize) => set({ pageSize }),
  setSearchQuery: (searchQuery) => set({ searchQuery }),
  setIsHidden: (isHidden) => set({ isHidden }),
  setIsLoading: (isLoading) => set({ isLoading }),
}));
